import React from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Box, Typography, Button, TextField } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../util/ApiHelper";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  last: {
    margin: 0,
  },
}));

const defaultValues = {
  hkiffId: process.env.REACT_APP_HKIFF_ID_NO,
  localizations: {
    en: {
      name: "",
    },
    tc: {
      name: "",
    },
  },
  status: false,
  seq: 0,
};

const SponsorsCategoryForm = ({ disabled, ...props }) => {
  const { history, fetchData, biggestSeq, setBiggestSeq } = props;
  const classes = useStylesAll();
  let { id } = useParams();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  React.useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getSponsorsCategoryById(id)
        .then((response) => {
          reset(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateSponsorCategory = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateSponsorsCategoryById(id, data);
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/sponsors-category");
    } catch (err) {
      console.log(err);
    }
  };

  const createSponsorCategory = async (data) => {
    try {
      await apiHelper.hkiff.createSponsorsCategory({...data, seq: biggestSeq + 1});
      toast.dark("SponsorCategory created.");
      //clear all fields
      reset(defaultValues);
      fetchData();
      setBiggestSeq(biggestSeq + 1);
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendSponsorCategory = () => {
      const req = {
        ...data,
        updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      };
      if (id) {
        updateSponsorCategory(req);
      } else {
        createSponsorCategory(req);
      }
    };
    sendSponsorCategory();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="localizations.en.name"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="localizations.tc.name"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Box width="25%">
              <Controller
                defaultValue={false}
                name="status"
                control={control}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState: { error },
                }) => (
                  <ToggleButtonGroup
                    {...rest}
                    value={value}
                    onChange={(event, newFormats) => {
                      onChange(newFormats);
                    }}
                    exclusive
                    aria-label="status"
                    size="large"
                    fullWidth
                  >
                    <ToggleButton
                      className={classes.root}
                      value={true}
                      aria-label="active"
                      disabled={disabled}
                    >
                      Active
                    </ToggleButton>
                    <ToggleButton
                      className={classes.root}
                      value={false}
                      aria-label="inactive"
                      disabled={disabled}
                    >
                      Inactive
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}
              />
            </Box>
            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
};

export default SponsorsCategoryForm;
